import React, { useState, useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import { AboutSection, DetermineSection, WhySection, AdmissionSection, DepartmentSection, TCSection } from '../components/Section';
import SeparatorComponent from '../components/SeparatorComponent';
import { Modal, Button } from 'react-bootstrap';

const HomePage = () => {
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const today = new Date();
        const start = new Date('2025-04-20');
        const end = new Date('2025-04-30');

        if (today >= start && today <= end) {
            setShowModal(true);
        }
    }, []);

    const handleClose = () => setShowModal(false);

    return (
        <>
            {/* Summer Camp Popup */}
            <Modal show={showModal} onHide={handleClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>🌞 समर कैंप की जानकारी</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <img 
                        src={require('../assets/Summercamp.jpg')} 
                        alt="Summer Camp Poster" 
                        style={{ width: '100%', height: 'auto', borderRadius: '8px' }} 
                    />
                    <div className="mt-3">
                        <Button 
                            variant="success" 
                            href="https://your-registration-link.com" 
                            target="_blank"
                        >
                            समर कैंप के लिए रजिस्टर करें
                        </Button>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        बंद करें
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Page Sections */}
            <HeroSection />
            <SeparatorComponent />
            <WhySection />
            <SeparatorComponent />
            <TCSection />
            <SeparatorComponent />
            <AboutSection />
            <SeparatorComponent />
            <AdmissionSection />
            <SeparatorComponent />
            <DepartmentSection />
            <SeparatorComponent />
            <DetermineSection />
            <SeparatorComponent />
        </>
    );
};

export default HomePage;
